import React from "react";
import { createBrowserRouter } from "react-router-dom";
import Layout from "./Layout/AppLayout";
import Login from "./Pages/Authentication/Login";
import Registration from "./Pages/Authentication/Registration";
import Inventory from "./Pages/Inventory/Inventory";
import LoanRequests from "./Pages/Loans/LoanRequests";
import Loans from "./Pages/Loans/Loans";
import ProductProfile from "./Pages/Products/ProductProfile";
import Products from "./Pages/Products/Products";
import UserLoanDistribution from "./Pages/Users/Components/UserLoan/UserLoanDistribution";
import UserLoanInstalmentDetails from "./Pages/Users/Components/UserLoan/UserLoanInstalmentDetails";
import UserLoanInstalments from "./Pages/Users/Components/UserLoan/UserLoanInstalments";
import UserLoanLogs from "./Pages/Users/Components/UserLoan/UserLoanLogs";
import UserLoanReceipt from "./Pages/Users/Components/UserLoan/UserLoanReceipt";
import UserProfile from "./Pages/Users/UserProfile3";
import Users from "./Pages/Users/Users";
import Transactions from "./Pages/Transactions/Transactions";
import Dashboard from "./Pages/Dashboards/Dashboard";
import UserLoanTransactions from "./Pages/Users/Components/UserLoan/UserLoanTransactions";
import FindUser from "./Pages/Users/FindUser";
import CreateProductForm from "./Pages/Products/Components/CreateProductForm";
import CustomerRegistration from "./Pages/Authentication/CustomerRegistration";
import UserAccountProfile from "./Pages/Users/Components/UserAccounts/UserAccountProfileV2";
import LoanRequestProfile from "./Pages/Loans/LoanRequestProfile";
import Customers from "./Pages/Users/customers";
import FindCustomer from "./Pages/Users/FindCustomer";
import UserTransactions from "./Pages/Users/Components/userTransactions";
import AccountsPage from "./Pages/Authentication/AccountsPage";
import ForgotPassword from "./Pages/Authentication/ForgotPassword";
import WithdrawRequests from "./Pages/PoolFund/WithdrawRequests";
import UserLoanProfile from "./Pages/Users/Components/UserLoan/UserLoanProfile";
import TransactionsWithdrawReq from "./Pages/Transactions/TransactionsWithdrawReq";
import PoolBasket from "./Pages/PoolFund/PoolBasket";
import RegistrationFees from "./Pages/Reports/RegistrationFees";
import Shares from "./Pages/Reports/Shares";
import SavingsReport from "./Pages/Reports/SavingsReport";
import Refunds from "./Pages/Reports/Refunds";
import CommissionsPaid from "./Pages/Reports/CommisionsPaid";
import LoansGiven from "./Pages/Reports/LoansGiven";
import PrinciplePaid from "./Pages/Reports/PrinciplePaid";
import InstallmentRepaid from "./Pages/Reports/InterestRepaid";
import RolloverInstallment from "./Pages/Reports/RolloverInstallment";
import Recovery from "./Pages/Reports/Recovery";
import AutoLogout from "./Hooks/AutoLogout";
import CreateUserForm from "./Pages/Users/Components/CreateUserForm";
import UserLoans from "./Pages/Users/Components/UserLoan/UserLoans";
import MemberShares from "./Pages/Shares/MemberShares";
import ProductProfile2 from "./Pages/Products/ProductProfile2";
import UserProfileInfo from "./Pages/Users/Components/UserProfileInfo";
import GuarantorNominations from "./Pages/Users/Components/Guarantors/GuarantorNominations";
import Guarantors from "./Pages/Users/Components/Guarantors/Guarantors";
import Deposits from "./Pages/Transactions/Deposits";
import UserSavings from "./Pages/Transactions/UserSavings";
import UserPoolTransactions from "./Pages/PoolFund/UserPoolTransactions";
import BankAccounts from "./Pages/Settings/BankAccounts";
import ProtectedRoute from "./Components/ProtectedRoute";
import CheckApprovals from "./Pages/Finance/CheckApprovals";
import SuspenseAccount from "./Pages/Finance/SuspenceAccount";
import PettyCash from "./Pages/Finance/PettyCash";
import DepositsC2BRecon from "./Pages/Reconciliation/DepositsC2BRecon";
import ApproveDepositsC2B from "./Pages/Reconciliation/ApproveDepositsC2B";
import WithdrawsB2C from "./Pages/Reconciliation/WithdrawsB2C";
import ReconciliationStatus from "./Pages/Reconciliation/ReconciliationStatus";
import SasraSavingsReport from "./Pages/SasraReports/SavingsReport";
import LoanPortfolioReport from "./Pages/SasraReports/LoanPortfolioReport";
import LoanPortfolioSummary from "./Pages/SasraReports/LoanPortfolioSummary";
import DepositReturnReport from "./Pages/SasraReports/DepositReturnReport";
import LoanAgeingReport from "./Pages/SasraReports/LoanAgeingReport";
import SavingsShareReport from "./Pages/SasraReports/SavingsShareReport";
import ExtendedSharesReport from "./Pages/SasraReports/ExtendedSharesReport";
import ExtendedSavingsReport from "./Pages/SasraReports/ExtendedSavingsReport";
import LoanClassificationReport from "./Pages/SasraReports/LoanClassificationReport";
import Otp from "./Pages/Authentication/Otp";
import UserAccounts from "./Pages/Users/Components/UserAccounts/UserAccounts";
import Disbursements from "./Pages/Transactions/Disbursements";
import Setting from "./Pages/Settings/Setting";
import RouteError from "./Components/RouteError";
import ErrorDisplay from "./Components/ErrorDisplay";
import { Button } from "@mui/material";
import RegReports from "./Pages/BiReports/RegReports";
import BiReports from "./Pages/BiReports/BiReports";
import ViewReport from "./Pages/BiReports/ViewReport";
import DebtCollection from "./Pages/Reports/DebtCollection";
import GuarantorShipWalletStatements from "./Pages/Users/Components/Guarantors/GuarantorShipWalletStatements";
import PoolTransactions from "./Pages/Reports/PoolTransactions";

const Router = createBrowserRouter([
  {
    path: "/",
    element: <Login />,
    errorElement: <RouteError />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/user-accounts",
    element: <AccountsPage />,
  },
  {
    path: "/otp",
    element: <Otp />,
  },
  {
    path: "/customer-registration",
    element: <CustomerRegistration />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "/dashboard",
    element: (
      <ProtectedRoute>
        <AutoLogout>
          <Layout />
        </AutoLogout>
      </ProtectedRoute>
    ),
    children: [
      {
        path: "",
        element: <Dashboard />,
      },
      {
        path: "transactions",
        children: [
          {
            path: "",
            element: <Transactions />,
          },
          {
            path: "deposits",
            element: <Deposits />,
          },
          {
            path: "savings",
            element: <SavingsReport />,
          },
          {
            path: "pool-transactions",
            element: <PoolTransactions />,
          },
        ],
      },
      {
        path: "find-user",
        element: <FindUser />,
      },
      {
        path: "customers",
        children: [
          {
            path: "",
            element: <Customers />,
          },
          {
            path: "find-customer",
            element: <FindCustomer />,
          },
        ],
      },
      {
        path: "finance",
        children: [
          {
            path: "petty-cash-records",
            element: <PettyCash />,
          },

          {
            path: "cheque-approvals",
            element: <CheckApprovals />,
          },
          {
            path: "disbursements",
            element: <Disbursements />,
          },
          {
            path: "suspense-account",
            element: <SuspenseAccount />,
          },
        ],
      },
      {
        path: "reconciliation",
        children: [
          {
            path: "deposits-c2b-recon",
            element: <DepositsC2BRecon />,
          },
          {
            path: "approve-deposits-c2b-recon",
            element: <ApproveDepositsC2B />,
          },
          {
            path: "withdraws-b2c-recon",
            element: <WithdrawsB2C />,
          },
          {
            path: "recon-status",
            element: <ReconciliationStatus />,
          },
        ],
      },
      {
        path: "sasra",
        children: [
          {
            path: "savings-report",
            element: <SasraSavingsReport />,
          },
          {
            path: "loan-portfolio-report",
            element: <LoanPortfolioReport />,
          },
          {
            path: "loan-portfolio-summary",
            element: <LoanPortfolioSummary />,
          },
          {
            path: "deposit-return-report",
            element: <DepositReturnReport />,
          },
          {
            path: "loan-ageing-report",
            element: <LoanAgeingReport />,
          },
          {
            path: "savings-share-report",
            element: <SavingsShareReport />,
          },
          {
            path: "extended-share-report",
            element: <ExtendedSharesReport />,
          },
          {
            path: "extended-savings-report",
            element: <ExtendedSavingsReport />,
          },
          {
            path: "loan-classification-report",
            element: <LoanClassificationReport />,
          },
        ],
      },
      {
        path: "users",
        children: [
          {
            path: "",
            element: <Users />,
          },
          {
            path: "create-user",
            element: <CreateUserForm />,
          },
          {
            path: "user-profile",
            children: [
              {
                path: "",
                element: <UserProfile />,
              },
              {
                path: "user-deposits",
                element: <UserTransactions />,
              },
              {
                path: "account-profile",
                element: <UserAccountProfile />,
              },
              {
                path: "loan-profile",
                element: <UserLoanProfile />,
              },
              {
                path: "loan-transactions",
                element: <UserLoanTransactions />,
              },
              {
                path: "loan-logs",
                element: <UserLoanLogs />,
              },
              {
                path: "loan-instalments",
                children: [
                  {
                    path: "",
                    element: <UserLoanInstalments />,
                  },
                  {
                    path: "loan-instalment-details",
                    children: [
                      {
                        path: "",
                        element: <UserLoanInstalmentDetails />,
                      },
                      {
                        path: "receipt",
                        element: <UserLoanReceipt />,
                      },
                      {
                        path: "distribution",
                        element: <UserLoanDistribution />,
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: "user",
        children: [
          {
            path: "user-profile",
            element: <UserProfileInfo />,
          },
          {
            path: "user-loans",
            // element: <UserLoans />,
            children: [
              {
                path: "",
                element: <UserLoans />,
              },
              {
                path: "loan-profile",
                element: <UserLoanProfile />,
              },
            ],
          },
          {
            path: "user-transactions",
            element: <UserTransactions />,
          },
          {
            path: "user-shares",
            element: <MemberShares />,
          },
          {
            path: "user-guarantor-nominations",
            element: <GuarantorNominations />,
          },
          {
            path: "guarantorship-wallet-statements",
            element: <GuarantorShipWalletStatements />,
          },
          {
            path: "user-guarantors",
            element: <Guarantors />,
          },
          {
            path: "user-deposits",
            element: <Deposits />,
          },
          {
            path: "user-savings",
            element: <UserSavings />,
          },
          {
            path: "user-pool-fund-transactions",
            element: <UserPoolTransactions />,
          },
        ],
      },

      {
        path: "products",
        children: [
          {
            path: "",
            element: <Products />,
          },
          {
            path: "product-profile",
            element: <ProductProfile2 />,
          },
          {
            path: "create-product",
            element: <CreateProductForm />,
          },
        ],
      },

      {
        path: "inventory",
        element: <Inventory />,
      },

      {
        path: "loans",
        children: [
          {
            path: "",
            element: <Loans />,
          },
          {
            path: "loan-profile",
            element: <UserLoanProfile />,
          },
        ],
      },
      {
        path: "loan-requests",
        children: [
          {
            path: "",
            element: <LoanRequests />,
          },
          {
            path: "profile",
            element: <LoanRequestProfile />,
          },
        ],
      },
      {
        path: "pool-fund-withdraw-requests",
        element: <WithdrawRequests />,
      },
      {
        path: "transactions-withdraw-requests",
        element: <TransactionsWithdrawReq />,
      },
      {
        path: "pool-basket",
        element: <PoolBasket />,
      },
      {
        path: "bi-reports",
        // element: <BiReports />,
        children: [
          {
            path: "",
            element: <BiReports />,
          },
          {
            path: "view",
            element: <ViewReport />,
          },
        ],
      },
      {
        path: "reports",
        children: [
          {
            path: "debt-collection",
            element: <DebtCollection />,
          },
          {
            path: "registration-fees",
            element: <RegistrationFees />,
          },
          {
            path: "shares",
            element: <Shares />,
          },
          {
            path: "savings",
            element: <SavingsReport />,
          },
          {
            path: "refunds",
            element: <Refunds />,
          },
          {
            path: "commission-paid",
            element: <CommissionsPaid />,
          },
          {
            path: "loans-given",
            element: <LoansGiven />,
          },
          {
            path: "principle-repaid",
            element: <PrinciplePaid />,
          },
          {
            path: "installment-repaid",
            element: <InstallmentRepaid />,
          },
          {
            path: "rollover-installment",
            element: <RolloverInstallment />,
          },
          {
            path: "Recovery",
            element: <Recovery />,
          },
        ],
      },
      {
        path: "system",
        children: [
          {
            path: "settings",
            element: <Setting />,
          },
          {
            path: "bank-accounts",
            element: <UserAccounts />,
          },
        ],
      },
      {
        path: "*",
        element: (
          <ErrorDisplay
            message="Page Not Found"
            details="The page you are looking for does not exist."
            actions={
              <Button variant="contained" href="/dashboard">
                Go to Dashboard
              </Button>
            }
          />
        ),
      },
    ],
  },
  {
    path: "*",
    element: <RouteError />,
  },
]);

export default Router;
